import { getCookie } from "./cookie";

const isBrowser =
  typeof window !== "undefined" && typeof window.navigator !== "undefined";

export const langs = [
  {
    value: "zh-CN",
    label: "中文",
  },
  {
    value: "en-US",
    label: "English",
  },
  // {
  //   value: "ja-JP",
  //   lable: "日文",
  // },
];

export function getDefaultLang() {
  if (typeof document == "undefined") {
    return langs[0].value;
  }
  let matched;
  if (isBrowser) {
    const cookieLang = getCookie("_authing_lang");
    if (cookieLang) {
      return cookieLang;
    }

    const computerLang = navigator.language || navigator.userLanguage;
    matched = langs.find((item) =>
      item.value.toLocaleLowerCase().includes(computerLang)
    );
  }
  return (matched || langs[0]).value;
}
